import { Area } from '@ff-os/shared-utils/types/Area';
import { Size } from '@ff-os/shared-utils/types/Size';

export const areSameOrientation = (size: Size, crop: Area) => {

    if (size?.borderAspectRatio) {
        return true;
    }

    const imageRatio = crop.width / crop.height;
    const sizeRatio = size.width / size.height;
    return (sizeRatio >= 1 && imageRatio >= 1) || (sizeRatio <= 1 && imageRatio <= 1);
};